// extracted by mini-css-extract-plugin
export default {"btnMain":"EditAnnouncement_btnMain__oqFPU","users__list":"EditAnnouncement_users__list__OCdtS"};